let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1e4dR")).then(() => parcelRequire('dAfv1'));